<template>
    <v-app>
        <v-app-bar
            app
            class="app-bar"
            clipped-left
            :color="headerColor"
            dark
            fixed
        >
            <v-btn elevation="0" icon @click.stop="drawer = !drawer">
                <v-icon>mdi-menu</v-icon>
            </v-btn>

            <v-toolbar-title>
                <img v-if="projectLogo" class="logo" :src="projectLogo" :alt="'Logo ' + projectName"/>
                <span>{{ projectName }}</span>
            </v-toolbar-title>

            <v-spacer/>
            <account></account>
        </v-app-bar>

        <v-main class="main" style="padding: 0">
            <v-navigation-drawer v-model="drawer" app clipped>
                <navigation></navigation>
            </v-navigation-drawer>
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import Navigation from "@/components/navigation";
import Account from "@/components/account";
import Config from "../config.singleton";

export default {
    name: 'Main',
    components: {Navigation, Account},
    data: () => ({
        drawer: null,
        version: "0.0.0",
    }),
    computed: {
        projectName() {
            return Config.project_name ?? this.$t("global.app_name")
        },
        projectLogo() {
            return Config.project_logo
        },
        headerColor() {
            return Config.primary_color ?? 'headerColor'
        }
    },
};
</script>
